<div
  data-at-active-maintenance-notification
  class="notification-container flex flex-col gap-[16px]"
  *ngFor="let maintenanceNotification of maintenanceNotifications"
>
  <div class="flex flex-row justify-between items-start">
    <div class="notification-description break-word">
      {{
        customTranslationsService.MAINTENANCE_NOTIFICATIONS[ACTIVE_ERROR_TYPE.MAINTENANCE]
          | translate
      }}
    </div>
    <app-pill [type]="pillType.primary">
      {{
        customTranslationsService.MAINTENANCE_NOTIFICATIONS[ACTIVE_ERROR_TYPE.MAINTENANCE]
          | translate
      }}
    </app-pill>
  </div>
  <div class="flex flex-col gap-[8px]">
    <div class="cause">
      <div>
        <ng-container
          *ngrxLet="devicesStore.getCascadeMemberId(maintenanceNotification.deviceId) as memberId"
        >
          <div class="device-type-wrapper">
            <div
              *ngIf="devicesStore.isV2Cascade$ | async"
              class="device-type"
              matTooltip="{{
                customTranslationsService.MAINTENANCE_NOTIFICATIONS_CASCADES[
                  maintenanceNotification?.deviceType?.toUpperCase()
                ] | translate
              }} {{ memberId }}
        "
            >
              {{
                customTranslationsService.MAINTENANCE_NOTIFICATIONS_CASCADES[
                  maintenanceNotification?.deviceType?.toUpperCase()
                ] | translate
              }}
              {{ memberId }}
            </div>
            <div class="spacer"></div>
          </div>
          <ul>
            <!-- Main Description  -->
            <li>
              {{
                customTranslationsService.MAINTENANCE_NOTIFICATIONS[maintenanceNotification.type]
                  | translate
              }}
            </li>
            <!-- Additional description -->
            <ul
              class="element-list"
              *ngIf="maintenanceNotification.type === ACTIVE_ERROR_TYPE.FILTER_EXCHANGE_14_DAYS"
            >
              <li>
                {{
                  customTranslationsService.MAINTENANCE_NOTIFICATIONS[
                    ACTIVE_ERROR_DESCRIPTION.FILTER_EXCHANGE_14_DAYS
                  ] | translate
                }}
              </li>
            </ul>
            <ul
              class="element-list"
              *ngIf="maintenanceNotification.type === ACTIVE_ERROR_TYPE.BATTERY_LOW"
            >
              <li
                *ngFor="
                  let deviceID of activeErrorsStore.selectDeviceIdForLowBatteryNotification$ | async
                "
              >
                <div class="flex flex-col">
                  <span
                    class="label"
                    *ngIf="(gatewayStore.getDeviceRoles(deviceID) | async).length"
                  >
                    {{ gatewayStore.getDeviceRoles(deviceID) | async | translateDeviceByRoles }}
                  </span>
                  <ng-container
                    *ngIf="getDeviceNameFeature(deviceID) | async | ready as deviceName"
                  >
                    <span *ngIf="deviceName.properties.name.value">
                      {{
                        customTranslationsService.MAINTENANCE_NOTIFICATIONS[
                          ACTIVE_ERROR_DESCRIPTION.DESCRIPTION
                        ] | translate
                      }}:
                      {{ deviceName | value2: featurePropertyKey.name }}
                    </span>
                  </ng-container>
                  <span class="device-id">
                    {{
                      customTranslationsService.MAINTENANCE_NOTIFICATIONS[
                        ACTIVE_ERROR_DESCRIPTION.ID
                      ] | translate
                    }}
                    {{ deviceID | idPrefixRemover | serialSpacing }}</span
                  >
                </div>
                <div
                  class="flex flex-row flex-wrap"
                  *ngIf="installationFeaturesStore.getDeviceRoom(deviceID) | async | ready as room"
                >
                  <span class="label">
                    {{
                      customTranslationsService.MAINTENANCE_NOTIFICATIONS[
                        ACTIVE_ERROR_DESCRIPTION.ROOM_NAME
                      ] | translate
                    }}
                    {{ room?.properties?.name?.value }}
                  </span>
                </div>
              </li>
            </ul>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</div>
